module.exports = __webpack_public_path__ + "img/menu.84af9020.svg";